




















































































import { mapState } from "vuex";

import { Component, Vue, Watch } from "vue-property-decorator";
import { PaymentWithUser, PlatformUserAccount } from "@/interfaces/payment";
import { Route } from "vue-router";
import { Tenant } from "@/interfaces/tenants";
import { TenantApiClient } from "@/api/tenant_client";
import { displayDate } from "@/date";
import CardComponent from "@/components/CardComponent.vue";
@Component({
  computed: {
    ...mapState(["tenants"])
  },
  components: { CardComponent }
})
export default class Users extends Vue {
  // Mapped from vuex
  tenants!: Tenant[];

  displayDate = displayDate;

  // Other Variables
  private api = new TenantApiClient();

  public tenant: Tenant = {
    name: "",
    description: "",
    web_url: "",
    tenant_id: ""
  };

  public users: PlatformUserAccount[] = [];
  public perPage = 25;
  public isLoading = true;

  public defaultThumbnailUrl: string =
    process.env.VUE_APP_DEFAULT_THUMBNAIL_URL;

  mounted() {
    this.setTenant(this.$route.params.tenant_id);
    this.loadContent();

    this.$store.commit("clearBreadcrumbs");
    this.$store.commit("pushBreadcrumbs", {
      to: `/tenant/${this.tenant.tenant_id}`,
      label: this.tenant.name
    });
    this.$store.commit("pushBreadcrumbs", {
      label: "User Verwaltung"
    });
  }

  // Watchers
  @Watch("$route")
  onRouteChange(newValue: Route) {
    this.setTenant(newValue.params.tenant_id);
    this.loadContent();
  }

  loadContent() {
    this.isLoading = true;
    this.api
      .listUsers(this.tenant.tenant_id)
      .then(users => {
        this.users = users;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  setTenant(tenantId: string) {
    this.tenants.forEach(tenant => {
      if (tenant.tenant_id === tenantId) {
        this.tenant = tenant;
      }
    });
  }
}
